import { eventBus } from '@atc/cai-event-bus';
import { UDS_SDP_ONTRACK_COMPLETED } from '../constants/events.js';
async function buildHooksObject(hooks, offer) {
  const {
    onDRLoaded,
    onDRTrack,
    onDRHidden
  } = hooks || {};
  const handleOnDRLoaded = error => {
    if (error) {
      // eslint-disable-next-line no-console
      console.warn('Error loading the DR Overlay: ', error.message);
    }
    if (onDRLoaded) onDRLoaded(error, offer);
  };
  const handleOnDRTrack = (name, action, data) => {
    eventBus.emit(UDS_SDP_ONTRACK_COMPLETED, {
      name,
      action,
      data
    });
    if (onDRTrack) onDRTrack(name, action, data);
  };
  const handleOnDRHidden = () => {
    // eslint-disable-next-line no-console
    console.log('DR Overlay was closed.');
    if (onDRHidden) onDRHidden();
  };
  return {
    onTrack: handleOnDRTrack,
    onLoadedFunction: handleOnDRLoaded,
    onHidingFunction: handleOnDRHidden
  };
}
export { buildHooksObject as default };
